export interface IDealerReminder {
  Company: number
  USD_BAK: number
  EUR_BAK: number
  TL_BAK: number
  VGA_USD: number
  VGA_EUR: number
  VGA_TL: number
  BAK_USD: number
  BAS_USDI: number
  USD_VGA: number
  USD_VGAI: number
}

export interface IInstallmentPrices {
  InstallmentNumber: number
  Price: string
  TotalPrice: string
}
export interface IBinResponse {
  BankCode: number
  BankName: string
  BinNumber: string
  CardAssociation: string
  CardFamilyName: string
  CardType: string
  Commercial: number
  Force3Ds: number
  ForceCvc?: number
  InstallmentPrices: IInstallmentPrices[]
  Message: string
  Success: boolean
}

export interface PaymentRequestMySpecial {
  HolderName: string
  CardNumber: string
  ExpireDate: string
  Cvc: string
  Installment: number
  Amount: number
  ComissionAmount: number
  Company: number
  InterestRate: number
  BankId: string
  Currency: string
  IsIncluding: boolean
  DealerLimitId?: number
  AmountHash?: string
  isMT: boolean
  RealPrice: string
  IMEI?: string
}

export interface IPaymentInvoice {
  FatuaNo: string
  Tutar: number
  IsClosed: boolean
}

export interface IPaymentOrder {
  OrderNo: string
  Tutar: number
  IsClosed: boolean
}

export interface PaymentRequestFcvMySpecial extends PaymentRequestMySpecial {
  Faturalar?: IPaymentInvoice[]
  Siparisler?: IPaymentOrder[]
  FcvId: number
}

export interface IGetInstallmentSpecialRequest {
  Company: string
  BinNumber: string
  Type: number
  Amount: number
  IsIncluding: boolean
  PaymentTermsId?: number
  // Yalnız remote kullanıcıda kabul edilir; Peşine Kontrat sorgusunda gönderilmez.
  CommissionFree?: boolean
  // Peşine Kontrat taksit sorgusu: oranlar PK tablosundan, komisyon hariç hesaplanır.
  IsPk?: boolean
  Imei?: string
}
export interface IBankInfos {
  BinNumber: string
  Commercial: number
  Price: string
  CardType: string
  CardAssociation: string
  CardFamilyName: string
  Force3Ds: number
  BankCode: number
  BankName: string
  ForceCvc: number
  InstallmentPrices: any
}
export interface IGetInstallmentSpecial {
  Type: string
  StartDate: Date
  EndDate: Date
  BankName: string
  BankNote: string
  AdditionalInstallment: string
  Installment: number
  InterestRate: number
  Id: number
  DealerCodes: string
  BankId: string
  ComissionAmount: number
  TotalAmount: number
  Company: string
  TotalMain: number
  TotalRate: number
  ComissionAmountValue: string
  TotalAmountValue: string
  TotalAmountTLValue: string
  TotalAmountDolarValue: string
  TotalAmountEuroValue: string
  InfoValueDolar: string
  InfoValueEuro: string
  InfoValueTL: string
  ParamPosDetail?: IParamPosDetail
}

export interface IParamPosDetail {
  POSName?: string,
  Installment: number,
  InterestRate: number,
  TotalRate: number,
  ComissionAmount: number,
  ComissionAmountValue: string,
  TotalAmount: number,
  TotalAmountTLValue: string,
  TotalAmountDolarValue: string,
  TotalAmountEuroValue: string,
  TotalMain: number,
  InfoValue: number,
  InfoValueTL: string,
  InfoValueDolar: string,
  InfoValueEuro: string
}

export interface ILimit {
  CompanyCode: string
  Id: number
  Limit: number
  RemainingTotal: number
  PaymentTermsName: string
  PaymentTermsId: number
  UsedTotal: number
}

export enum PaymentTypeEnum {
  Avantaj = 0,
  Firsat = 1,
  Fcv = 2,
  CariOdeme = 3,
}

export interface IDealerLimit {
  List: ILimit[]
  Type: PaymentTypeEnum
}

export interface IInvoice {
  AnlikKur: number
  BelgeParaBirimi: string
  Company: string
  FCVID: number
  FCVName: string
  FaturaID: number
  FaturaNo: string
  SiparisNo: string
  SiparisTarihi: Date
  FaturaTarihi: Date
  OdenmisMiktar: number
  ToplamTry: number
  Toplam?: number
  IsOrder?: boolean
}

export interface IAllPaymentData {
  DealerReminders?: IDealerReminder[]
  DealerLimits?: IDealerLimit[]
  Invoices?: IInvoice[]
  IsIncludedList?: string[]
}

export interface IPaymentDetail {
  Amount: number
  Bank: string
  Date: Date
  DealerCode: string
  DealerName: string
  DocumentNo: string
  Installment: number
  NameSurname: string
  ReceiptNumber: string
  CrediCard: string
  ExpireDate: string
  RealPrice: string
}

export interface IBanner {
  Id: number
  Title: string
  Description: string
  Location: number
  CompanyList: number[]
  Category: number
  Order: number
  Active: true
  StartDate: Date
  EndDate: Date
  CariTypeCode: []
  CariSubTypeCode: []
  Image: string
  ImageUrl: string
  MobilImage: string
  MobilImageUrl: string
  CounterLocation: number
  DontShowToUsers: string
  ProductCode: []
  ProductAddress: string
  BannerType: number
  VideoId: string
  IsHomepage: true
}

export interface PaymentControl {
  Amount: number
  BinNumber: string
  Company: string
  IsIncluding: boolean
  PaymentTermsId: number
  CommissionType: number
  Type: number
  Installment: number
  UserId: number
  // Peşine Kontrat ödemesi: sunucu PK anlık görüntüsünü bu onay kaydına yazar; ödeme ancak bu kayıtla başlar.
  IsPk?: boolean
  Imei?: string
}

// payment/paymentControl dönüşü. Eskiden boolean'dı; pop-up'ın bağlanacağı satır Id'si gerekiyor.
export interface IPaymentControlResponse {
  PaymentControlId: number
  VerificationRequired: boolean
  ShortText: string | null
}

export interface IManualCreditCardPaymentControl {
  Amount: number
  BinNumber: string
  Company: string
  DealerCode: string
  ComissionType: number
  Installment: number
  // Peşine Kontrat ödemesi (remote): sunucu PK anlık görüntüsünü bu onay kaydına yazar.
  IsPk?: boolean
  Imei?: string
}

export interface IManualCreditCardPayment {
  HolderName: string
  CardNumber: string
  ExpireDate: string
  Cvc: string
  Installment: number
  Amount: number
  Company: number
  DealerCode: string
  InterestRate: number
  BankID: string
  Currency: string
  ComissionType: number
  ComissionAmount: number
  RealPrice: string
  IMEI?: string
}

export interface IInstallmentInquiry {
  Company: string
  DealerCode: string
  Amount: number
  BinNumber: string
  ComissionType: number
  // Peşine Kontrat taksit sorgusu (remote): oranlar PK tablosundan hesaplanır.
  IsPk?: boolean
  Imei?: string
}


export interface ILastPaymentResponse {
  Company: string
  CreatedDate: Date
  OrderNumber: string
  RealPrice: string
  TransactionNumber: string
  Types: number
}

/**
 * Döviz bazlı ödeme aç/kapa durumu (payment/getPaymentCurrencyControl).
 * Bayraklar genel Payment bayrağının altında çalışır: genel ödeme kapalıysa
 * döviz açık olsa da ödeme alınmaz. Notlar kapalı dövizin gerekçesini taşır.
 */
export interface IPaymentCurrencyControl {
  Payment: boolean
  TL: boolean
  USD: boolean
  EUR: boolean
  NoteTL?: string
  NoteUSD?: string
  NoteEUR?: string
}
